export default __webpack_public_path__ + "static/google-review-c2908b4e82bd789e8f16d68404bf8f8b.svg";